import { Globe2, Linkedin } from "lucide-react";
import type { NetworkKey } from "../lib/networks";
import { BRAND_GLYPH_PATHS } from "./brand-glyph-paths";

// Every glyph paints with currentColor, so the surrounding CSS decides the
// colour and the whole set stays in the Score Creator purple instead of seven
// competing brand colours. LinkedIn and Site are lucide glyphs: LinkedIn was
// withdrawn from Simple Icons over trademark, and a personal site has no brand.
export function NetworkIcon({ network, size = 18 }: { network: NetworkKey; size?: number }) {
  if (network === "LINKEDIN") return <Linkedin size={size} aria-hidden="true" />;
  if (network === "WEBSITE") return <Globe2 size={size} aria-hidden="true" />;
  return (
    // `brand-glyph` marks the filled Simple Icons paths. Lucide's glyphs are
    // stroke-based with fill="none", so a blanket `fill: currentColor` would
    // collapse the globe and the LinkedIn mark into solid discs.
    <svg className="brand-glyph" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      <path d={BRAND_GLYPH_PATHS[network]} />
    </svg>
  );
}
